import {socket} from '../../../../shared/scripts/EntryShared'
import {PlayerColor} from '@colonist/game-states'
import {UIReplayController} from '../../../../shared/scripts/ui_replay/UIReplayController'
import {getReplayInitiationData, getReplayUrlActionIndex} from '../../../../shared/scripts/ui_replay/ReplayUrlUtilities'
import {UIGameSpriteHandler} from '../../../../shared/scripts/UIGameSpriteHandler'
import {uiManager} from '../../EntryHomepage'
import {Scene} from '../../ui_html/UISceneTypes'

export class UIDReplaySceneController {
    private replayController: UIReplayController | undefined

    loadReplay(gameId: string, playerColor: PlayerColor) {
        this.replayController?.destroy()
        this.replayController = undefined

        UIGameSpriteHandler.continueAfterAssetsLoad(async() => {
            try {
                const replayUrl = new URL(`https://colonist.io/replay?gameId=${gameId}&playerColor=${playerColor}`)
                const replayInitiationData = await getReplayInitiationData(replayUrl.href)
                const replayActionIndex = getReplayUrlActionIndex(replayUrl.href)
                const isLiveReplay = false
                this.replayController = new UIReplayController(replayInitiationData, socket.actionController, isLiveReplay, replayActionIndex)

                uiManager?.sceneController.loadScene(Scene.Game)
            } catch(e) {
                uiManager?.sceneController.loadScene(Scene.DiscordStore)
            }
        })
    }
}
